<template lang="">
  <div class="modal-desktop">
    <!-- Modal Trigger -->
    

    <!-- Modal Structure -->
    <div id="modal1" class="modal">
      <div class="modal-header">  
            <h4> Descripcion de la solicitud: {{ ModalData.idNum }} </h4>
      </div>  
      <div class="modal-content">
        <div class="row">
          <div class="col s12">

          <div class="col s3">
            <h6>    OT  </h6>
            <div v-if=" ModalData.OT == undefined "> 
              <span >Asignar OT </span> 
              <div class="switch">
                <label>
                  <input v-model="showInputOT" type="checkbox">
                  <span class="lever"></span>
                </label>
              </div>
              <transition name="fade">
                <div class="" v-show="showInputOT">
                  <div class="input-field col s9">
                    <input v-model="newOt" placeholder="#OT - 123456 " type="text">
                  </div>
                  <div class="input-field col s3">
                    <a @click="saveOT()" class="btn-floating btn-medium waves-effect waves-light blue"><i class="material-icons">save</i></a>
                  </div>
                </div>
              </transition>
            </div>
            <div v-else>
              <p> {{ ModalData.OT }} </p>
            </div>
          </div>
          <div class="col s3">
            <h6>   Cliente </h6>
            <p>  {{ ModalData.cliente }} </p>
          </div>
          <div class="col s3">
            <h6> Usuario que solicito  </h6>
            <p>  {{ ModalData.UsrSol }} </p>
          </div>
          <div class="col s3">
            <!--  Fecha  -->
            <h6> Fecha de solicitud </h6>
            <p>  {{ getDateFormat(ModalData.created,"D") }} </p>
          </div>
        </div>

        <div class="col s12">
          <div class="col s6">
            <!--  Parametros de la solicitud  -->
            <h6> Parametros de la solicitud  </h6>
            <ul>
              <li>  Departamento: {{ ModalData.departamento }} </li>
              <li>  Area de maniobra: {{ ModalData.AreaManiobra }} </li>
              <li>  Altura: {{ ModalData.altura }} </li>
              <li>  Peso: {{ ModalData.peso }} </li>
              <li>  Radio: {{ ModalData.radio }} </li>
            </ul>
          </div>
          <div class="col s6">
        <!--  Resumen del servicio del servcio  Operador, ayudante, unidad,  -->
                <h6> Resumen del servicio </h6>
                <ul>
                  <li>  Fecha de servicio: {{ getDateFormat(ModalData.fecha,"D") }} </li>
                  <!-- <li>  Unidad Asignada: {{ ModalData.Unidad }} </li> -->
                  <li>  Grua Tipo: {{ ModalData.gruaTipo }} </li>
                  <li>  Operador: {{ ModalData.Operador }} </li>
                  <li>  Ayudante: {{ ModalData.Ayudante }} </li>
                </ul>          
          </div>
        </div>

        <div class="col s12">
          <div class="col s4">
            <!--  Descripcion de la solicitud -->
              <h6> Descripcion de la  solicitud </h6>
              <p>  {{ ModalData.descripcion }} </p>
          </div>
          <div class="col s4">
            <!--  Comentarios del CLientes  -->
            <h6> Comentarios del Cliente  </h6>
            <p>  {{ ModalData.comentarioCliente }} </p>
            <p>  smileyRating:  {{ ModalData.smileyRating }}</p>
          </div>                    
          <div class="col s4">
            <!--  Costos . . . -->
            <h6> Costos   </h6>
            <ul>
              <li> Costo por Hora: {{ ModalData.costoHora }} </li>
              <li> Costo de traslado:  {{ ModalData.costoTraslado }} </li>
              <li> Costo por hora extra:  {{ ModalData.costoHoraExtra }} </li>
            </ul>
          </div>
        </div>

        </div><!-- END ROW -->

        <!-- <div>  <!--  Fecha 
          <h5> Fecha de solicitud </h5>
          <p>  {{ getDateFormat(ModalData.created,"D") }} </p>
        </div> -->


        <div>  
        </div>

      </div>
      <div class="modal-footer">
        <!-- <a class="waves-effect waves-light btn"><i class="material-icons right">cloud</i>button</a -->
        <a v-if="infoStatus()" @click="closeOnBackOffice()" class="mr-20 modal-close waves-effect waves-green btn-small red darken-4"><i class="material-icons left">check_circle</i>Finalizar Servicio </a>
        <a class="modal-close waves-effect waves-green btn-small blue darken-4"><i class="material-icons left">close</i>Cerrar </a>
      </div>
    </div>

  </div>
</template>
<style lang="scss" scoped>
  .mr-20{margin-right: 20px !important;}
  .modal-content{margin-top:55px;}
  .modal-header {
    height: 50px;
    background-color: #0f62a9;
    width: 100%;
    display: block;
    text-align: center;
    position: fixed;
    -webkit-box-shadow: 0px 3px 10px #4c8ff5;
    box-shadow: 0px 3px 10px #4c8ff5;
    border: 1px solid #7575756b;
    color: #fff;
    & h4{
      line-height: 50px;    }
  }
  .modal-footer{ 
    border-top:solid 1px #ccc;
    & a {  
      padding-left: 10px;
      padding-right: 10px;
    }
    }
  .modal{
    width: 75% !important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .8s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
<script>
import M from 'materialize-css'
import axios from 'axios';
import {func} from '../func'
import firebase from '../config'
const { db } = firebase;
export default {
  name:"ModalDesktop",
  components:{},
  props: ["ModalData"],
  data() {
    return {
      showInputOT:false,
      newOt:"",
      modal:{},
      
    }
  },
  // props: [datos],
  created() {
    },
  mounted() {
    console.log("ModalData: ", this.ModalData);
    
    },
  methods: {
    infoStatus(){
      if( this.ModalData.status){
        if( this.ModalData.status[1] && this.ModalData.status[1] == 4)
          return true
        else
          return false
      }
    },
    closeOnBackOffice(){
      // let _showE = document.querySelector("#ID-"+this.strId).value;
      let _self = this;
      let $_id = this.ModalData.id;
      let _d = {
        status:["Modificada",5,"Finalizada"],
        smileyRating: "N/A",
        comentarioCliente: "Cerrado en BackOffice",
        finishHim: true,
        // finishHim: true,
      }; 
      console.log(_d)
      db.collection('todos').doc($_id).update(_d)
      .then ( () => {
          _self.dismissModal();
      } );
    },
    saveOT(){
      let _self = this;
      let arr = ["Modificada",4,"OT asignada"];
      let _datos = {};
      if( _self.newOt == "" ){
        alert(" La Orden de trabajo no puede estar vacia.");
        return;
      }
        //  let OT = document.querySelector("#ot-asig").value
      _datos.status = arr;
      _datos.OT = _self.newOt; 

      if (  window.localStorage.getItem('messagingToken') != null ){
        _datos.ADMSToken =  window.localStorage.getItem('messagingToken');
      }        
      _datos.asignacionOt = true; 
    
      let $_id       = _self.ModalData.id;
      let token     = _self.ModalData.token;
      let solicitud = _self.ModalData.idNum

      db.collection('todos').doc($_id).update(_datos)
      .then ( () => {
        // _self.saveTokenActualUsr();
        if( token != null ){
          axios.post(`https://us-central1-mi-test-b974c.cloudfunctions.net/SendMessage`,{ "token": token, "solicitud": solicitud  })
            .then( r => {
              console.log("Notificacion enviada con exito", r)
            })
            .catch( error => { console.log("Se presento un error durante el envio de la notificacion ", error);_self.dismissModal(); } )
        }else{
          _self.dismissModal();
          // NO CONTAMOS CON UN TOKEN PARA LA NOTIFICACION  . . . . .
        }
        _self.dismissModal();
      });
    },
    getOt($o){
      if($o == undefined ){
        return "ND"
      }else{
        return $o;
      }
    },
    getDateFormat($d,$f,b) {
      return func.getDateFormat($d,$f,b);
      // if($d == null )
      //   return;
      // let now = new Date($d);
      // let f = ($f == "D") ? dt(now, "yyyy, mmmm d"): dt(now, "h:MM TT") ;
      // return f;
    },
    dismissModal() {
      let elems = document.querySelector("#modal1");
      let modal = M.Modal.init(elems, {});
      modal.close();
    },
    openModal(){
      let elems = document.querySelector("#modal1");
      this.modal = M.Modal.init(elems, {});
      this.modal.open();
    },
  },
}
</script>